<template>
  <div>
    <v-layout
      row
      align-center
      mb-2
    > 
      <v-flex xs2 :style="nameStyle">
        {{ item.qty }} x
      </v-flex>
      <v-flex xs8>
        <span :style="nameStyle">{{ itemName }}
          <span
            v-if="item.voucher_id || item.is_promo"
            class="promotion"
          > ({{ $t('promotion_item') }})</span>
        </span>
        <div v-if="item.remarks">
          <span :style="remarksStyle"
          >{{ $t('remarks') }}: {{ item.remarks }}</span>
        </div>
      </v-flex>
      <v-flex
        xs2
        class="text-xs-right"
        :style="nameStyle"
      >
        {{ $n(amount, 'currency') }}
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'order-item-component',
  props: {
    item: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'iOS', 'inIframe', 'language'
    ]),
    nameStyle () {
      return {
        fontWeight: 500,
        color: this.theme.orders_title_color
      }
    },
    qtyStyle () {
      return {
        color: this.theme.menu_qty_color
      }
    },
    remarksStyle () {
      return {
        color: this.theme.cart_remarks_color,
        fontSize: '13px'
      }
    },
    amount () {
      if (this.item) {
        return parseFloat(this.item.price) * this.item.qty
      }
      return 0
    },
    itemName () {
      if (this.language !== 'en-SG') {
        return this.item.name2 || this.item.name
      }
      return this.item.name
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/BillOrder.vue